var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74865 15.2283C6.92072 15.4147 7.15016 15.5163 7.41237 15.5163C7.94498 15.5163 8.36287 15.0843 8.36287 14.5338C8.36287 14.2628 8.26455 14.0087 8.07608 13.8223L2.31568 8.01207L8.07608 2.20179C8.26455 2.01545 8.36288 1.76136 8.36288 1.49033C8.36288 0.948259 7.94498 0.5163 7.41237 0.5163C7.15016 0.5163 6.92072 0.609469 6.74865 0.795804L0.357303 7.24979C0.144258 7.46153 0.0295411 7.72409 0.0295411 8.01207C0.0295411 8.30004 0.136064 8.55413 0.357303 8.77435L6.74865 15.2283Z",
    fill: "black",
    fillOpacity: 0.68
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.cc9725fab519cae68579659365b29705.svg";
export { ForwardRef as ReactComponent };